import React from 'react';

import {
  MultipleSelectProps,
  SelectInnerProps,
  SingleSelectProps,
} from './model';
import { SelectMultiple } from './SelectMultiple';
import { SelectSingle } from './SelectSingle';

export const Select = ({
  isSingle = true,
  isBannerEditPage,
  ...props
}: SelectInnerProps & { isBannerEditPage?: boolean }) => {
  if (isSingle) {
    const singleProps = props as SingleSelectProps;
    return (
      <SelectSingle {...singleProps} isBannerEditPage={isBannerEditPage} />
    );
  }
  const multipleProps = props as MultipleSelectProps;
  return <SelectMultiple {...multipleProps} />;
};
